import { useEffect, useState } from "react";
import api from "@/lib/apiClient";
import AdminLayout from "@/layouts/AdminLayout";
import { adminNav } from "@/lib/navConfig";
import { PageHeader } from "@/components/Common";

const LABELS = {
  timesheet_relinked: "Auto-attributed",
  timesheet_assign: "Manually assigned",
  timesheet_bulk_assign: "Bulk assigned",
};
const CLS = {
  timesheet_relinked: "bg-sky-100 text-sky-700",
  timesheet_assign: "bg-emerald-100 text-emerald-700",
  timesheet_bulk_assign: "bg-indigo-100 text-indigo-700",
};

export default function RepairLog() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/audit-logs", { params: { actions: "timesheet_relinked,timesheet_assign,timesheet_bulk_assign", limit: 300 } })
      .then((r) => setRows(r.data)).catch(() => {});
  }, []);
  return (
    <AdminLayout nav={adminNav} title="Repair Log">
      <PageHeader title="Timesheet Repair Log" subtitle="What the system reconnected automatically, and manual assignments — most recent first" />
      <div className="bg-white border border-zinc-200 rounded-md overflow-x-auto kqm-scroll">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-xs font-semibold uppercase tracking-wider text-zinc-500 border-b border-zinc-200">
            <th className="p-3">When</th><th className="p-3">Action</th><th className="p-3">By</th><th className="p-3">Timesheet</th><th className="p-3">Detail</th>
          </tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} data-testid={`repair-row-${r.id}`} className="border-b border-zinc-50 hover:bg-zinc-50">
                <td className="p-3 num text-zinc-500 whitespace-nowrap">{(r.timestamp || "").slice(0, 16).replace("T", " ")}</td>
                <td className="p-3"><span className={`text-[11px] font-semibold px-2 py-0.5 rounded ${CLS[r.action] || "bg-slate-100 text-slate-700"}`}>{LABELS[r.action] || r.action}</span></td>
                <td className="p-3">{r.user_name || "—"}</td>
                <td className="p-3 num text-xs text-zinc-500">{r.entity_id ? String(r.entity_id).slice(0, 8) : (r.after?.count != null ? `${r.after.count} timesheets` : "—")}</td>
                <td className="p-3 text-xs text-zinc-500">{r.after?.via ? `via ${r.after.via}` : ""}{r.after?.employee_id ? `${r.after?.via ? " · " : ""}→ employee ${String(r.after.employee_id).slice(0, 8)}` : ""}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={5} className="p-6 text-center text-sm text-zinc-400" data-testid="repair-empty">No repairs or manual assignments recorded yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
